import styled from "styled-components";

export const ContentContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 600px;
  max-width: 90vw;
  max-height: 85vh;
  background: transparent;
  padding: 0;
  box-sizing: border-box;

  overflow-y: auto; /* enable scroll */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
`;
export const Title = styled.span`
  font-family: "Avenir-Heavy-Medium", sans-serif;
  font-size: 22px;
  text-align: center;
  max-width: 30rem;

  letter-spacing: -0.177777px;

  color: #fff;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  opacity: 0.5;
  margin-bottom: 10px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  align-items: center;
  width: 100%;
`;

export const Button = styled.button`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 5px;
  background-color: #484888;
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  padding: 12px;
  border-radius: 20px;

  font-family: "Avenir-Heavy", sans-serif;
  font-size: 16px;
  letter-spacing: -0.177777px;
  color: #fff;
  text-transform: uppercase;

  &:hover {
    background-color: ${(props) => (props.$disabled ? "#a16f7e" : "#484888")};
    transition: all 0.2s ease-out;
  }
  &:active {
    transition: scale 0.3s ease-in;
    transform: ${(props) => (props.$disabled ? "scale(0.95)" : "unset")};
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0);
  }
`;
export const StyledButton = styled(Button)`
  padding: 10px 24px;
`;

export const ButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;

export const Textarea = styled.textarea`
  width: 100%;
  font-family: "Avenir-Heavy", sans-serif;
  font-size: 18px;
  letter-spacing: -0.177777px;
  color: #fff;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.15);
  -webkit-box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
  box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
  padding: 20px; /* ⬅️ slightly more padding inside */
  border-radius: 20px;
  min-height: 220px;
  outline: none;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const TitlePrompt = styled.span`
  font-family: "Avenir-Heavy", sans-serif;
  font-size: 18px;
  color: #fff;
  align-self: flex-start;
  margin-left: 5px;
  margin-top: 20px;
  margin-bottom: 10px;
  letter-spacing: -0.177777px;
`;
